import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../../urls";
import { BasicSourcingEventView } from "./BasicSourcingEventView";

export const BseViewRoute = () => {
  const { eventId } = useParams();
  const location = useLocation();

  if (eventId) {
    return <Navigate to={`${urls.v2.sourcingEvents.bseView.go(eventId)}${location.search}${location.hash}`} replace />;
  }

  return <BasicSourcingEventView />;
};
